import { render, staticRenderFns } from "./DeskGroups.vue?vue&type=template&id=3a7ec941"
import script from "./DeskGroups.vue?vue&type=script&lang=js"
export * from "./DeskGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports